"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckStepdeck = function SvgIconTruckStepdeck(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck stepdeck icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Stepdeck Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.605 16.999L46 24.389v9.236h-3.599c0 3.056-2.415 5.539-5.395 5.539-2.981 0-5.395-2.483-5.395-5.539H16.39c0 3.056-2.418 5.539-5.397 5.539-2.98 0-5.395-2.483-5.395-5.539H2v-4.804h23.781l3.391-4.433h3.852v-7.39h7.581zm-3.599 19.396c1.49 0 2.699-1.244 2.699-2.77 0-1.534-1.209-2.77-2.699-2.77-1.491 0-2.698 1.236-2.698 2.77 0 1.526 1.207 2.77 2.698 2.77zm-26.014 0c-1.49 0-2.699-1.244-2.699-2.77 0-1.534 1.209-2.77 2.699-2.77 1.487 0 2.698 1.236 2.698 2.77 0 1.526-1.21 2.77-2.698 2.77zm24.216-12.007h8.028l-3.531-4.616h-4.497v4.616z"
  }));
};

var _default = SvgIconTruckStepdeck;
exports.default = _default;